export function isNoEmptyString(value) {
    return (typeof value === 'string' && value.length);
}